const CourseCardSkeleton = () => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden animate-pulse">
      {/* Image Skeleton */}
      <div className="h-48 bg-gray-200"></div>
      
      {/* Content Skeleton */}
      <div className="p-5">
        {/* Title */}
        <div className="h-6 bg-gray-200 rounded mb-2"></div>
        
        {/* Difficulty */}
        <div className="flex items-center mb-3">
          <div className="h-4 w-12 bg-gray-200 rounded mr-2"></div>
          <div className="flex gap-1">
            {Array.from({ length: 3 }, (_, i) => (
              <div key={i} className="w-4 h-4 bg-gray-200 rounded"></div>
            ))}
          </div>
          <div className="h-4 w-12 bg-gray-200 rounded ml-2"></div>
        </div>
        
        {/* Description */}
        <div className="space-y-2 mb-4">
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        </div>
        
        {/* Location and Duration */}
        <div className="space-y-2 mb-4">
          <div className="flex items-center">
            <div className="w-4 h-4 bg-gray-200 rounded mr-1"></div>
            <div className="h-4 bg-gray-200 rounded flex-1"></div>
          </div>
          <div className="flex items-center">
            <div className="w-4 h-4 bg-gray-200 rounded mr-1"></div>
            <div className="h-4 bg-gray-200 rounded w-24 mr-4"></div>
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </div>
        </div>
        
        {/* Action Button */}
        <div className="text-center pt-3 border-t">
          <div className="h-5 bg-gray-200 rounded w-24 mx-auto"></div>
        </div>
      </div>
    </div>
  );
};

export default CourseCardSkeleton;